import React, { useCallback, useMemo } from 'react';
import PageLayout from '../../components/PageLayout';
import { useAuth } from 'fennec-ui';
import { useLocaladminContext } from '../../../common/Context';
import GonorarBlock from '../../components/GonorarBlock';

export default function LocaladminComissionGonorar(props) {
    const local = useLocaladminContext();
    const x = useMemo(()=>({ organizatorRegionalnoeOtdelenieID: local?.ID }),[local])
    // const regionalnoeOtdelenie = useSelector(getRregionalnoeOtdelenieFromRoles(["АдминистраторОтделения", "АдминистраторМероприятийРО"], true));
    const auth = useAuth()

    return (
        <PageLayout>
            <div style={{ padding: "10px" }}>
                <GonorarBlock {...props} source={"/api/shablonisudeiskikhgonorarov/list/reg"}
                    sourceKey="reg"
                    create={true}
                    ctx={x}
                />
            </div>
        </PageLayout>
    );
}
